import React from "react";
import { Col, Form, Input } from "antd";
import CustomDatepicker from "components/DatePicker";
import CustomRadioGroup from "components/CustomRadioGroup";
import CustomTextArea from "components/CustomTextArea";
import CustomSelect from "components/CustomSelect";
import CustomNumber from "components/CustomNumber";
import CustomButton from "components/CustomButton";
import CustomCheckBox from "components/CheckBox";
import CustomBrowse from "components/Browse";
import CustomSwitch from "components/CustomSwitch";
import CustomNumOfAmt from "components/NumOfAmt";
import MultiSelect from "components/MultiSelect";
import ImageUpload from "components/ImageUpload";

const FormItem = ({ itemType, span, xl, xs, label, name, rules, required = false, hasFeedback, ...props }) => {
  var tmpRules = [];
  if (rules) {
    tmpRules = [...rules];
  }
  if (required) {
    tmpRules = [
      ...tmpRules,
      {
        required: true,
        message: `${label} хоосон байна!`,
      },
    ];
  }
  return (
    <Col
      // span={span}
      xs={span ?? xs}
      xl={span ?? xl}
      // xxl={span ?? 6}
      style={itemType === "button" ? { textAlign: "right" } : {}}
    >
      <Form.Item label={label} name={name} rules={tmpRules} hasFeedback={hasFeedback}>
        {(() => {
          switch (itemType) {
            case "date":
              return <CustomDatepicker {...props} />;
            case "radio":
              return <CustomRadioGroup {...props} />;
            case "switch":
              return <CustomSwitch {...props} />;
            case "checkbox":
              return <CustomCheckBox {...props} />;
            case "select":
              return <CustomSelect {...props} />;
            case "button":
              return <CustomButton styles={{ borderRadius: "10px" }} {...props} />;
            // case "multipleSelect":
            //   return <TagInput {...props} />;
            case "textarea":
              return <CustomTextArea {...props} />;
            case "browse":
              return <CustomBrowse {...props} />;
            case "number":
              return <CustomNumber {...props} />;
            case "password":
              return <Input.Password allowClear {...props} />;
            case "amount":
              return <CustomNumOfAmt {...props} />;
            case "image":
              return <ImageUpload {...props} />;
            case "multipleSelect":
              return <MultiSelect {...props} />;
            default:
              return <Input allowClear {...props} />;
          }
        })()}
      </Form.Item>
    </Col>
  );
};
export default FormItem;
